<template>
    <div class="list_nav_wrap toggle-nav">
        <h1 class="list_nav_title">
            <label>{{ keyName }}</label><em>（万元）</em>
            <div class="custom-price no-active">
                <div class="custom" action="/buy.htm">
                    <div class="custom-title">自定义价格 »</div>
                    <div class="custom-con">
                        <input type="text"
                            name="minPrice"
                            v-model="custom.minPrice"
                            id="minprice"
                            class="custom-price-input">
                        -
                        <input type="text"
                            name="maxPrice"
                            v-model="custom.maxPrice"
                            id="maxprice" 
                            class="custom-price-input">
                        万元
                        <button class="custom-submit" @click.prevent="doSelectCustom()">确定</button>
                    </div>
                </div>
            </div>
        </h1>
        <div class="price-sc clearfix">
            <div class="unlimited">∞</div>
            <template v-for="item in list">
                <a class="price-range" click_type="list-nav-price-0"
                    :title="item.value + '万'"
                    @click="doSelect(item.value)">
                    <i :class="{
                        'price-active': active === item.value
                    }"></i>
                    <span>{{ item.name }}</span>
                </a>
            </template>
        </div>
    </div>
</template>

<script>
    import urlUtil from '@souche-f2e/chunyan-util/url_util/url_util.js';
    const locationObj = urlUtil.initByLocation();
    let priceArr = [0, 5, 8, 10, 15, 20, 30, 50];
    export default {
        data() {
            return {
                key: 'carPrice',
                keyName: '价格',
                active: locationObj.search.get('carPrice'),
                custom: {
                    minPrice: '',
                    maxPrice: ''
                },
                list: (function () {
                    var ret = [];
                    priceArr.forEach(function (m, i) {
                        let n;
                        if (i < priceArr.length - 1) {
                            n = priceArr[i + 1];
                        } else {
                            n = 1000;
                        }
                        ret.push({
                            value: `${m}-${n}`,
                            name: m
                        });
                    });
                    return ret;
                })()
            };
        },
        methods: {
            doSelect(value) {
                if (value) {
                    locationObj.s(this.key, value).s('index', null).go();
                } else {
                    locationObj.s(this.key, null).s('index', null).go();
                }
            },
            doSelectCustom() {
                if (!this.custom.minPrice) {
                    this.custom.minPrice = 0;
                }
                if (!this.custom.maxPrice) {
                    this.custom.maxPrice = 1000;
                }
                if (isNaN(this.custom.minPrice) || isNaN(this.custom.maxPrice)) {
                    /* eslint-disable */
                    alert('请输入正确的价格！');
                    /* eslint-enable */
                    this.custom.minPrice = '';
                    this.custom.maxPrice = '';
                    return false;
                }
                let value = `${this.custom.minPrice}-${this.custom.maxPrice}`;
                locationObj.s(this.key, value).s('index', null).go();
            }
        }
    };
</script>

<style lang="less" scoped>
    a {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// NavPrice.vue?1d4c8e08